const base = {
  flex: '0 1 100%',
  maxWidth: '100%',
  paddingTop: 's32',
  paddingRight: 0,
  paddingBottom: 's16',
  paddingLeft: 's24'
};

const panel = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  }
};

export const panelVariants = Object.keys(panel);

export type PanelType = 'default' | 'inverse';

export default panel;
